import { render, staticRenderFns } from "./AboutPopup.vue?vue&type=template&id=7d52d250&scoped=true&"
import script from "./AboutPopup.vue?vue&type=script&lang=ts&"
export * from "./AboutPopup.vue?vue&type=script&lang=ts&"
import style0 from "./AboutPopup.vue?vue&type=style&index=0&id=7d52d250&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d52d250",
  null
  
)

export default component.exports